<template>
  <div>
    <div class="row columns">
      <div class="large-12 columns">
        <div class="note text-left">Vous pouvez ajouter des actions pour ajouter de l'expérience à votre joueur.</div>
        <div class="note text-left"><strong>Les actions génèrent des Xp, et donc potentiellement des montées de niveaux classiques</strong></div>
        <div class="note text-left">La colonne blessure représente le nombre de blessures <strong>persistantes</strong>, pour mettre des pertes de carac, utilisez l'onglet stats</div>
      </div>
    </div>
    <br>
    <table>
      <thead class="roster-head">
      <tr>
        <th >Passes</th>
        <th >TTM</th>
        <th>Touchdowns</th>
        <th >Interception</th>
        <th >Détourn.</th>
        <th >Sorties</th>
        <th >JPV</th>
        <th >Aggressions</th>
        <th >Blessures</th>
      </tr>
      </thead>
      <tbody class="roster">
      <tr>
        <td class="small-input">
          <input type="number" min="0" class="line_input" v-model="action.nb_pass">
        </td>
        <td class="small-input">
          <input type="number" min="0" class="line_input" v-model="action.nb_ttm">
        </td>
        <td class="small-input">
          <input type="number" min="0" class="line_input" v-model="action.nb_td">
        </td>
        <td class="small-input">
          <input type="number" min="0" class="line_input" v-model="action.nb_int">
        </td>
        <td class="small-input">
          <input type="number" min="0" class="line_input" v-model="action.nb_det">
        </td>
        <td class="small-input">
          <input type="number" min="0" class="line_input" v-model="action.nb_cas">
        </td>
        <td class="small-input">
          <input type="number" min="0" class="line_input" v-model="action.nb_mvp">
        </td>
        <td class="small-input">
          <input type="number" min="0" class="line_input" v-model="action.nb_foul">
        </td>
        <td class="small-input">
          <input type="number" min="0" class="line_input" v-model="action.nb_niggling">
        </td>
      </tr>
      </tbody>
    </table>
    <button @click="reset()" class="alert">
      <span class="large-btn-icon"><i class="fa fa-minus" aria-hidden="true"></i>&nbsp;Réinitialiser</span>
    </button>
    <div class="row columns takeaway">
       <div class="large-12 text-centered">
          Les actions vont générer {{earnedXp}} Xp pour ce joueur
       </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'xp-customizer',
    props: {
      'detailedPlayer': {}
    },
    data () {
      return {
        action: {
          nb_td: 0,
          nb_pass: 0,
          nb_ttm: 0,
          nb_cas: 0,
          nb_det: 0,
          nb_int: 0,
          nb_mvp: 0,
          nb_foul: 0,
          nb_niggling: 0
        }
      }
    },
    computed: {
      earnedXp: function () {
        let xp = +this.action.nb_td * 3
        xp += +this.action.nb_pass
        xp += +this.action.nb_ttm
        xp += +this.action.nb_det
        xp += +this.action.nb_cas * 2
        xp += +this.action.nb_int * 2
        xp += +this.action.nb_mvp * 4
        return xp
      }
    },
    methods: {
      reset: function () {
        this.action.nb_td = 0
        this.action.nb_pass = 0
        this.action.nb_cas = 0
        this.action.nb_int = 0
        this.action.nb_mvp = 0
        this.action.nb_foul = 0
        this.action.nb_niggling = 0
      },
      isUsed: function () {
        if ((+this.action.nb_td !== 0 && this.action.nb_td !== '' && this.action.nb_td !== '0') ||
              (+this.action.nb_pass !== 0 && this.action.nb_pass !== '' && this.action.nb_pass !== '0') ||
              (+this.action.nb_cas !== 0 && this.action.nb_cas !== '' && this.action.nb_cas !== '0') ||
              (+this.action.nb_int !== 0 && this.action.nb_int !== '' && this.action.nb_int !== '0') ||
              (+this.action.nb_mvp !== 0 && this.action.nb_mvp !== '' && this.action.nb_mvp !== '0') ||
              (+this.action.nb_foul !== 0 && this.action.nb_foul !== '' && this.action.nb_foul !== '0') ||
              (+this.action.nb_niggling !== 0 && this.action.nb_niggling !== '' && this.action.nb_niggling !== '0')) {
          return true
        }
        return false
      }
    }
  }
</script>

<style scoped>
thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tbody.large-font tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:1.1rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.large-font {
  font-size: 1.1rem
}
.button-column {
  text-align: right;
}
.note {
  font-size: 0.8rem;
  font-weight: 200;
}
.stat {
  font-weight: 300;
}

.takeaway {
  margin-top: 1rem;
  background-color: #eaeaea;
  padding: 1rem;
}

</style>



// WEBPACK FOOTER //
// xp-customizer.vue?7c995e66